import axios from 'axios';

export default class Cookies {
    private selector: HTMLElement;

    constructor(selector: string) {
        this.selector = document.querySelector(selector);
        if (this.selector) {
            this.init();
        }
    }

    private init(): void {
        const button: HTMLElement = this.selector.querySelector('[data-cookies-button]');
        if (button) {
            button.addEventListener('click', this.hideCookies.bind(this));
        }
    }

    private hideCookies(e: Event): void {
        const button = e.target as HTMLElement;
        const cookies: HTMLElement = button.closest('[data-cookies]');

        axios.post('/endpoints/cookies');
        cookies.classList.add('cookies--hide');
    }
}
